import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { authApi } from '@/services/api'
import { useAuthStore } from '@/store/auth.store'
import { AlertTriangle, LogOut } from 'lucide-react'

export default function ImpersonationBanner() {
  const navigate = useNavigate()
  const [error, setError] = useState('')
  const { user: currentUser } = useAuthStore()

  const exitImpersonateMutation = useMutation({
    mutationFn: () => authApi.exitImpersonate(),
    onSuccess: (response) => {
      // Update auth store with original user
      if (response.data) {
        const { setAuth } = useAuthStore.getState()
        setAuth(response.data.user, response.data.token)
        // Redirect to users page and reload
        navigate('/dashboard/users')
        window.location.reload()
      }
    },
    onError: (err: any) => {
      setError(err.response?.data?.message || 'Failed to exit impersonation')
    },
  })

  const handleExitImpersonation = () => {
    if (window.confirm('Are you sure you want to exit impersonation?')) {
      exitImpersonateMutation.mutate()
    }
  }

  // Only show banner if impersonating
  if (!currentUser?.is_impersonating) {
    return null
  }

  return (
    <div className="bg-amber-500 text-white px-6 py-3">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center space-x-3">
          <AlertTriangle className="w-5 h-5" />
          <span className="font-medium">
            You are currently impersonating {currentUser?.first_name} {currentUser?.last_name} ({currentUser?.email})
          </span>
        </div>
        <button
          onClick={handleExitImpersonation}
          disabled={exitImpersonateMutation.isPending}
          className="flex items-center space-x-2 bg-white text-amber-600 px-4 py-2 rounded-md hover:bg-amber-50 transition-colors font-medium disabled:opacity-50"
        >
          <LogOut className="w-4 h-4" />
          <span>{exitImpersonateMutation.isPending ? 'Exiting...' : 'Exit Impersonation'}</span>
        </button>
      </div>
      {error && (
        <div className="mt-2 text-sm text-white bg-red-600 px-3 py-2 rounded">
          {error}
        </div>
      )}
    </div>
  )
}
